import 'ol/ol.css';
// import Feature from 'ol/Feature';
// import Map from 'ol/Map';
import {
  Pointer as PointerInteraction
} from 'ol/interaction';
import {
  isDefectDragHitLayer,
  isDraggableDefectFeatureId
} from '@/features/dashboard-map/hierarchy/mapFeatureClickPolicy';
import { resolveModuleDefectPk } from '@/utils/defect/defectShapeOverlay';

export default class MapFeatureDragHandler extends PointerInteraction {
  constructor(listener) {
    super({
      handleDownEvent: handleDownEvent,
      handleDragEvent: handleDragEvent,
      handleMoveEvent: handleMoveEvent,
      handleUpEvent: handleUpEvent
    });

    this.listener_ = listener;
    /**
     * @type {import("../src/ol/coordinate.js").Coordinate}
     * @private
     */
    this.coordinate_ = null;

    /**
     * @type {string|undefined}
     * @private
     */
    this.cursor_ = 'pointer';

    /**
     * @type {Feature}
     * @private
     */
    this.feature_ = null;

    /**
     * @type {string|undefined}
     * @private
     */
    this.previousCursor_ = undefined;
  }
}

/**
 * @param {import("../src/ol/MapBrowserEvent.js").default} evt Map browser event.
 * @return {boolean} `true` to start the drag sequence.
 */
function handleDownEvent(evt) {
  const map = evt.map;
  const hitOpts = { layerFilter: isDefectDragHitLayer };

  const feature = map.forEachFeatureAtPixel(
    evt.pixel,
    feat => (isDraggableDefectFeatureId(feat?.getId?.()) ? feat : undefined),
    hitOpts
  );

  if (feature) {
    this.coordinate_ = evt.coordinate;
    this.feature_ = feature;
    const coords = feature.getGeometry().getCoordinates();
    this.startCoords_ = Array.isArray(coords) ? coords.slice() : null;
  }

  return !!this.feature_;
}

/**
 * @param {import("../src/ol/MapBrowserEvent.js").default} evt Map browser event.
 */
function handleDragEvent(evt) {
  const deltaX = evt.coordinate[0] - this.coordinate_[0];
  const deltaY = evt.coordinate[1] - this.coordinate_[1];

  const geometry = this.feature_.getGeometry();
  geometry.translate(deltaX, deltaY);

  this.coordinate_[0] = evt.coordinate[0];
  this.coordinate_[1] = evt.coordinate[1];
}

/**
 * @param {import("../src/ol/MapBrowserEvent.js").default} evt Event.
 */
function handleMoveEvent(evt) {
  if (this.cursor_) {
    const map = evt.map;
    const feature = map.forEachFeatureAtPixel(
      evt.pixel,
      feat => (isDraggableDefectFeatureId(feat?.getId?.()) ? feat : undefined),
      { layerFilter: isDefectDragHitLayer }
    );
    const element = evt.map.getTargetElement();
    if (feature) {
      if (element.style.cursor != this.cursor_) {
        this.previousCursor_ = element.style.cursor;
        element.style.cursor = this.cursor_;
      }
    } else if (this.previousCursor_ !== undefined) {
      element.style.cursor = this.previousCursor_;
      this.previousCursor_ = undefined;
    }
  }
}

/**
 * @return {boolean} `false` to stop the drag sequence.
 */
function handleUpEvent(evt) {


  if(this.listener_){
    const featureCoords = this.feature_.getGeometry().getCoordinates();
    const startCoords = this.startCoords_;

    this.listener_(
      resolveModuleDefectPk(this.feature_.getProperties()),
      featureCoords[0],
      featureCoords[1],
      {
        feature: this.feature_,
        startLon: startCoords?.[0] ?? null,
        startLat: startCoords?.[1] ?? null
      }
    );
  }

  this.coordinate_ = null;
  this.feature_ = null;
  this.startCoords_ = null;
  return false;
}
